import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import { Alert } from 'react-bootstrap';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';

import akmApi from '../../../../../apis/akmApi';

class DeleteSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            urlBackup: null,
            dataBackup: []
        }
    }

    async componentDidMount(){
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            fetch('https://ep-deletesiswa-default-rtdb.firebaseio.com/ardipa2682021A16128.json', {
                method: "GET"
            })
            .then(res => res.json())
            .then(data => {       
                this.setState({ dataBackup: data  });
            })
        }     
    }

    onFileChange = (event) => {        
		this.setState({
			file: event.target.files[0]
		});
    }

    handleSubmit = async (e)=>{
        e.preventDefault();
        console.log(this.state);
        this.setState({ 
           isFetching : true 
        });

        let data = new FormData();
                
        data.append('file', this.state.file);
        
        const response = await akmApi.post(URL_AKM.DELETE_SISWA_EXCEL,
            data
        ).catch(function(error){
            this.setState({error})
        })

        if(response){
            this.setState({ 
                urlBackup: response.data.data.urlBackup
            });
        }

        this.setState({ 
            isFetching : false 
        });
    }

    render() { 
        const {isFetching, urlBackup, dataBackup} = this.state;
        return (
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />  
                    {this.loadAlert()}   
                    <div className="row">
                        <div className="col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <form onSubmit={this.handleSubmit}>  
                                        <div className="form-group">
                                            <label><span className="text-danger">*</span>Pilih File: </label> 
                                            <a style={{float: 'right'}} className="btn btn-outline-info" href='/DELETE_SISWA.xlsx'><i className="fa fa-download"></i></a>
                                            <br />
                                            <input type="file" className="form-control" required 
                                            onChange={this.onFileChange} id="file"
                                            accept=".xlsx" />
                                        </div>
                                        <button type="submit" value="Submit" className="btn btn-danger">
                                            <li className="fa fa-trash"> Delete !!</li>
                                        </button>
                                        <p><b>{urlBackup}</b></p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div className="row">
                        <div className="col-md-12">
                            <table>

                            
                            {!__.isEmpty(dataBackup.allSiswa) &&
                                dataBackup.allSiswa.map((val, i)=>
                                    <tr>
                                        <td>{val.namaSiswa}</td>
                                    </tr>
                                )
                            }
                            </table>
                        </div>
                    </div> 
                </div>
            </div>
        );
    }
    
    loadAlert = () => {
        const {alertShow,keterangan } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{keterangan}</strong>
            </Alert>
          );
        } 
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(DeleteSiswa);